export default class BackShopeeOrderReturn {
    userCode: string;
    orderNumber: number;
    createTime: Date;
    id: number;
    shipment: string;
    reMark: string;
    warehouseInfoId: number;
    returnTime: Date;
    whetherHandle: boolean;
    warehouseName: string;
}